(function () {
  function setupReviewLink() {
    const rating = document.querySelector('.jdgm-preview-badge');

    if (!rating || rating.dataset.berigloReviewLink === 'true') {
      return;
    }

    const reviewSection = document.querySelector('.jdgm-cards-carousel');

    if (!reviewSection) {
      return;
    }

    rating.dataset.berigloReviewLink = 'true';
    rating.style.cursor = 'pointer';

    rating.addEventListener('click', function () {
      reviewSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  setupReviewLink();

  const observer = new MutationObserver(function () {
    setupReviewLink();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();